import type { TenantScheduleDraft, TenantScheduleDraftAssignment, TenantScheduleDraftUpdatePayload } from '@tark/shared/types';

export function moveScheduleDraftAthlete(
  draft: TenantScheduleDraft,
  athleteId: number,
  targetSlotId: number | null
): TenantScheduleDraft {
  let moved: TenantScheduleDraftAssignment | undefined;
  const slots = draft.slots.map((slot) => {
    const current = slot.assignments.find((item) => item.athleteId === athleteId);
    moved = moved ?? current;
    return { ...slot, assignments: slot.assignments.filter((item) => item.athleteId !== athleteId) };
  });
  moved = moved ?? draft.unplaced.find((item) => item.athleteId === athleteId);
  if (!moved) return draft;

  const assignment = { ...moved, preferenceRank: null, reasonCode: targetSlotId == null ? 'MANUAL_UNPLACED' : 'MANUAL_OVERRIDE' };
  return {
    ...draft,
    slots: slots.map((slot) => slot.draftSlotId === targetSlotId
      ? { ...slot, assignments: [...slot.assignments, assignment].sort(byAthleteName) }
      : slot),
    unplaced: targetSlotId == null
      ? [...draft.unplaced.filter((item) => item.athleteId !== athleteId), assignment].sort(byAthleteName)
      : draft.unplaced.filter((item) => item.athleteId !== athleteId),
  };
}

export function buildScheduleDraftUpdate(draft: TenantScheduleDraft): TenantScheduleDraftUpdatePayload {
  return {
    version: draft.version,
    slots: draft.slots.map((slot) => ({
      draftSlotId: slot.draftSlotId,
      included: slot.included,
      startsAt: slot.startsAt,
      endsAt: slot.endsAt,
      locationLabel: slot.locationLabel,
      capacity: slot.capacity,
      athleteIds: slot.assignments.map((assignment) => assignment.athleteId),
    })),
    unplacedAthleteIds: draft.unplaced.map((assignment) => assignment.athleteId),
  };
}

export function toLocalDateTimeInput(value: string): string {
  const date = new Date(value);
  const offset = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}

export function fromLocalDateTimeInput(value: string): string {
  return new Date(value).toISOString();
}

export function scheduleDraftReason(reason?: string | null): string {
  const labels: Record<string, string> = {
    NO_RESPONSE: 'No family response',
    NONE_OF_THESE: 'No proposed time works',
    SCHEDULE_CONFLICT: 'Schedule conflict',
    CAPACITY: 'Preferred times are full',
    MANUAL_UNPLACED: 'Moved here by coach',
  };
  return reason ? labels[reason] || 'Needs coach review' : 'Needs coach review';
}

function byAthleteName(a: TenantScheduleDraftAssignment, b: TenantScheduleDraftAssignment): number {
  return a.athleteName.localeCompare(b.athleteName);
}
